module.exports = __webpack_public_path__ + "static/media/airplaneTakeoff.24ba446d.svg";